{
  "adminSignInLink": {
    "body": "Click the button below to access your Pointcare admin portal.",
    "cta": "Sign in to admin",
    "greeting": "Hello,",
    "ignore": "If you didn't request admin access, you can ignore this email.",
    "linkFallback": "If the button doesn't work, copy and paste this link:",
    "signoff": "Thanks,\nThe Pointcare team",
    "subject": "Your Pointcare admin sign-in link"
  },
  "reset": {
    "body": "We got a request to reset the password for your Pointcare account. Click the button below to create a new one.",
    "cta": "Reset my password",
    "greeting": "Hello,",
    "ignore": "If you did not request this, you can safely ignore this email. Your password will not change.",
    "signoff": "Thanks,\nThe Pointcare team",
    "subject": "Reset your Pointcare password"
  },
  "signInLink": {
    "body": "Tap the button below to confirm your email and set up your Pointcare account.",
    "cta": "Confirm my email",
    "greeting": "Hello,",
    "ignore": "Didn't sign up for Pointcare? You can ignore this email.",
    "linkFallback": "If the button doesn't work, copy and paste this link:",
    "signoff": "Thanks,\nThe Pointcare team",
    "subject": "Confirm your email for Pointcare"
  }
}
